// @flow
import * as React from 'react';

import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.palette.greyScale[2],
    height: '100%',
    fontSize: 18,
    textDecoration: 'none',
    '& :hover': {
      textDecoration: 'none',
    },
  },
  clickable: {
    cursor: 'pointer',
  },
  primary: {
    fontSize: 18,
    marginBottom: 10,
    fontWeight: 500,
  },
  primarySmall: {
    extend: 'primary',
    fontSize: 14,
  },
  secondary: {
    fontSize: 18,
    maxWidth: '80%',
    textAlign: 'center',
  },
  secondarySmall: {
    lineHeight: 'normal',
    extend: 'secondary',
    fontSize: 14,
  },

});

type Props = {
  onClick: (Event) => void,
  icon: ?any,
  style: Object,

  primary: ?(string | React.Node),
  primaryTypographyProps: ?Object,

  secondary: ?(string | React.Node),
  secondaryTypographyProps: ?Object,

  disableTypography: ?boolean,
  useSmallerFont: ?boolean,
  children?: React.Node,

  textOnTop: ?boolean,
  iconSize: Object,
  // from withStyles
  classes: Object,
  className: string,
};

// we set this to transparent for now, don't seem to need it and don't want clutter on load
const ZeroStateView = (props: Props) => {
  const {
    children,
    classes,
    disableTypography,
    icon,
    onClick,
    primary: primaryProp,
    primaryTypographyProps,
    secondary: secondaryProp,
    secondaryTypographyProps,
    useSmallerFont,
    textOnTop,
    iconSize,
    className,
  } = props;

  let primary = primaryProp === undefined ? 'No Data' : primaryProp;
  // $FlowFixMe
  if (primary != null && primary.type !== Typography && !disableTypography) {
    primary = (
      <Typography
        variant="subtitle1"
        className={useSmallerFont ? classes.primarySmall : classes.primary}
        {...primaryTypographyProps}
      >
        {primary}
      </Typography>
    );
  }

  let secondary = secondaryProp;

  // $FlowFixMe
  if (secondary != null && secondary.type !== Typography && !disableTypography) {
    secondary = (
      <Typography
        variant="body2"
        className={useSmallerFont ? classes.secondarySmall : classes.secondary}
        color="textSecondary"
        {...secondaryTypographyProps}
      >
        {secondary}
      </Typography>
    );
  }

  return (
    <div
      className={classNames(classes.root, onClick ? classes.clickable : null, className)}
      onClick={onClick}
      role="none"
      style={props.style}
    >
      {textOnTop &&
      <>
        {primary}
        {secondary}
        <br/>
      </>
      }

      {icon &&
        <>
          <img alt="nothing to report" src={icon} style={iconSize ? {...iconSize} : { height: 60, width: 60 }} />
          <br />
        </>
      }

      {children}

      {!textOnTop &&
      <>
        {primary}
        {secondary}
      </>
      }
    </div>
  );
};

export default withStyles(styles)(ZeroStateView);
